var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', {
    staticClass: "feedback-settings settings-card"
  }, [_c('div', {
    staticClass: "feedback-heading"
  }, [_vm._m(0), _c('button', {
    staticClass: "secondary-button",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.loadItems
    }
  }, [_vm._v(" " + _vm._s(_vm.loading ? "Obnovujem..." : "Obnoviť") + " ")])]), _c('div', {
    staticClass: "feedback-stats"
  }, [_c('div', {
    staticClass: "stat-card stat-card--all"
  }, [_c('strong', [_vm._v(_vm._s(_vm.total))]), _c('span', [_vm._v("všetkých hlásení")])]), _c('div', {
    staticClass: "stat-card stat-card--new"
  }, [_c('strong', [_vm._v(_vm._s(_vm.statusCount("new")))]), _c('span', [_vm._v("nových")])]), _c('div', {
    staticClass: "stat-card stat-card--progress"
  }, [_c('strong', [_vm._v(_vm._s(_vm.statusCount("in_progress")))]), _c('span', [_vm._v("rieši sa")])]), _c('div', {
    staticClass: "stat-card stat-card--resolved"
  }, [_c('strong', [_vm._v(_vm._s(_vm.statusCount("resolved")))]), _c('span', [_vm._v("vyriešených")])])]), _c('div', {
    staticClass: "feedback-filters"
  }, [_c('label', {
    staticClass: "filter-field feedback-search"
  }, [_c('span', [_vm._v("Hľadať")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.search,
      expression: "search",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "placeholder": "Popis, používateľ, URL alebo ID hypotéky"
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.search = $event.target.value.trim();
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('label', {
    staticClass: "filter-field"
  }, [_c('span', [_vm._v("Stav")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedStatus,
      expression: "selectedStatus"
    }],
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Všetky stavy")]), _vm._l(_vm.statuses, function (status) {
    return _c('option', {
      key: status.value,
      domProps: {
        "value": status.value
      }
    }, [_vm._v(" " + _vm._s(status.label) + " ")]);
  })], 2)])]), _vm.loading && !_vm.items.length ? _c('div', {
    staticClass: "feedback-state"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner small",
    attrs: {
      "indeterminate": ""
    }
  }), _c('span', [_vm._v("Načítavam feedback...")])], 1) : _vm.loadError && !_vm.items.length ? _c('div', {
    staticClass: "feedback-state feedback-state--error"
  }, [_c('strong', [_vm._v("Feedback sa nepodarilo načítať.")]), _c('span', [_vm._v("Skontrolujte nasadenie API a skúste to znova.")]), _c('button', {
    staticClass: "secondary-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadItems
    }
  }, [_vm._v("Skúsiť znova")])]) : !_vm.filteredItems.length ? _c('div', {
    staticClass: "feedback-state"
  }, [_c('strong', [_vm._v(_vm._s(_vm.items.length ? "Filtru nezodpovedá žiadne hlásenie." : "Zatiaľ neprišiel žiadny feedback."))]), _vm.items.length ? _c('span', [_vm._v("Zmeňte vyhľadávanie alebo vybraný stav.")]) : _vm._e()]) : _c('section', {
    staticClass: "feedback-list",
    attrs: {
      "aria-label": "Hlásenia používateľov"
    }
  }, _vm._l(_vm.filteredItems, function (item) {
    return _c('article', {
      key: item.id,
      staticClass: "feedback-item"
    }, [_c('header', {
      staticClass: "feedback-item-heading"
    }, [_c('div', {
      staticClass: "feedback-author"
    }, [_c('span', {
      staticClass: "feedback-id"
    }, [_vm._v("#" + _vm._s(item.id))]), _c('div', [_c('strong', [_vm._v(_vm._s(item.reporter_name || "Neznámy používateľ"))]), _c('span', [_vm._v(_vm._s(_vm.formatDate(item.created)))])])]), _c('label', {
      staticClass: "status-control",
      "class": _vm.statusClass(item.status)
    }, [_c('span', [_vm._v("Stav")]), _c('select', {
      attrs: {
        "disabled": _vm.isSaving(item.id)
      },
      domProps: {
        "value": item.status
      },
      on: {
        "change": function change($event) {
          return _vm.updateStatus(item, $event.target.value);
        }
      }
    }, _vm._l(_vm.statuses, function (status) {
      return _c('option', {
        key: status.value,
        domProps: {
          "value": status.value
        }
      }, [_vm._v(" " + _vm._s(status.label) + " ")]);
    }), 0)])]), _c('p', {
      staticClass: "feedback-message"
    }, [_vm._v(_vm._s(item.message))]), _c('div', {
      staticClass: "feedback-context"
    }, [_c('a', {
      attrs: {
        "href": item.page_url,
        "target": "_blank",
        "rel": "noopener noreferrer",
        "title": item.page_url
      }
    }, [_c('span', [_vm._v("Stránka")]), _c('strong', [_vm._v(_vm._s(_vm.displayUrl(item.page_url)))])]), item.mortgage ? _c('router-link', {
      attrs: {
        "to": "/karta-hypoteky/".concat(item.mortgage, "/detail")
      }
    }, [_c('span', [_vm._v("Hypotéka")]), _c('strong', [_vm._v("#" + _vm._s(item.mortgage))])]) : _vm._e(), item.client ? _c('div', [_c('span', [_vm._v("Klient")]), _c('strong', [_vm._v("#" + _vm._s(item.client))])]) : _vm._e(), item.route_name ? _c('div', [_c('span', [_vm._v("Obrazovka")]), _c('strong', [_vm._v(_vm._s(item.route_name))])]) : _vm._e()], 1), item.screenshot ? _c('div', {
      staticClass: "feedback-screenshot"
    }, [_c('a', {
      attrs: {
        "href": item.screenshot,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      attrs: {
        "src": item.screenshot,
        "alt": "Screenshot k feedbacku #".concat(item.id)
      }
    }), _c('span', [_vm._v("Otvoriť screenshot v plnej veľkosti")])])]) : _vm._e(), _vm.hasContext(item.context) ? _c('details', {
      staticClass: "technical-context"
    }, [_c('summary', [_vm._v("Technický kontext")]), _c('pre', [_vm._v(_vm._s(_vm.formatContext(item.context)))])]) : _vm._e()]);
  }), 0), _vm.items.length < _vm.total ? _c('button', {
    staticClass: "load-more",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingMore
    },
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v(" " + _vm._s(_vm.loadingMore ? "Načítavam..." : "Na\u010D\xEDta\u0165 \u010Fal\u0161ie (".concat(_vm.total - _vm.items.length, ")")) + " ")]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "section-kicker"
  }, [_vm._v("Podpora používateľov")]), _c('h2', [_vm._v("Feedback používateľov")]), _c('p', [_vm._v(" Popis situácie, stránka, hypotéka a screenshot sú spolu v jednom zázname. ")])]);

}]

export { render, staticRenderFns }